import React, { useState, useContext, useEffect, useCallback } from 'react';
import { useFormik } from 'formik';
import Button from '../../bootstrap/Button';
import FormGroup from '../../bootstrap/forms/FormGroup';
import Checks, { ChecksGroup } from '../../bootstrap/forms/Checks';
import Label from '../../bootstrap/forms/Label';
import Modal, { ModalBody, ModalHeader, ModalTitle } from '../../bootstrap/Modal';
import Spinner from '../../bootstrap/Spinner';
import { DefaultContext } from '../../../contexts/default';
import Input from '../../bootstrap/forms/Input';
import showNotification from '../../extras/showNotification';
import notificationBody from '../../../helpers/utils/functions/notificationBody';
import api from '../../../services/api';




const validate = (values) => {
  const errors = {};

  if (!values.serial) {
    errors.serial = 'O número de série é obrigatório.';
  }

  if (!values.active) {
    errors.active = 'Você precisa escolher o status do terminal.';
  }

  if (!values.location) {
    errors.location = 'A localização é obrigatória.';
  }

  return errors;
};

const ModalRegisterTerminal = ({ open, setIsOpen, setIsClose, terminalSelected }) => {
  const { estabSelected, storeSelected } = useContext(DefaultContext);
  const [isLoading, setIsLoading] = useState(false);

  const resetFormState = useCallback(() => {
    formik.resetForm();
  }, [formik]);

  useEffect(() => {
    if (open) {
      resetFormState();
      if (terminalSelected && Object.keys(terminalSelected || {}).length > 0) {
        formik.setValues({
          serial: terminalSelected.serial || '',
          active: terminalSelected.active ? 'ativo' : 'inativo',
          location: terminalSelected.location || '',
        });
      } else {
        formik.setFieldValue('active', 'ativo', false);
      }
    }
  }, [open, resetFormState, terminalSelected, storeSelected]);

  const handleClose = useCallback(() => {
    resetFormState();
    setIsClose();
  }, [resetFormState, setIsClose]);

  const formik = useFormik({
    initialValues: {
      serial: '',
      location: '',
      active: 'ativo',
      model: null,
    },
    validate,
    onSubmit: async values => {
      setIsLoading(true);

      const data = {
        estabId: estabSelected,
        storeId: storeSelected,
        location: values.location,
        serial: values.serial,
        active: values.active === 'ativo',
      };

      try {
        if (terminalSelected) {
          await api.put('/terminal', data);
          showNotification('', notificationBody('Terminal atualizado com sucesso'), 'success');
        } else {
          await api.post('/terminal', data);
          showNotification('', notificationBody('Terminal cadastrado com sucesso'), 'success');
        }
        handleClose();
      } catch (error) {
        const apiMessage =
          (error && error.response && error.response.data && error.response.data.message) ||
          (error && error.response && error.response.data && error.response.data.error) ||
          (error && error.message) ||
          (error && error.code) ||
          'Erro desconhecido';
        showNotification('', notificationBody(apiMessage), 'danger');
      } finally {
        setIsLoading(false);
      }
    },
  });

  return (
    <Modal
      id={'modal-register-terminal'}
      titleId={'Cadastro de Terminal'}
      isOpen={open}
      setIsOpen={setIsOpen}
      isStaticBackdrop={true}
      isScrollable={false}
      isCentered={true}
      size="md"
      isAnimation={true}
      onSubmit={formik.handleSubmit}
    >
      <ModalHeader setIsOpen={handleClose}>
        <ModalTitle id="register-totem">
          {terminalSelected ? 'Atualização de Terminal' : 'Adicionar Terminal'}
        </ModalTitle>
      </ModalHeader>
      <ModalBody className='p-5'>
        <form noValidate onSubmit={formik.handleSubmit}>
          <div className="row pb-2 d-flex">
            <div className='row mb-4'>
              <FormGroup id='location' label='Localização' className='col-md-9 mb-4 '>
                <Input
                  id='location'
                  name='location'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.location}
                  isValid={formik.isValid}
                  isTouched={formik.touched.location}
                  invalidFeedback={formik.errors.location}
                  validFeedback='Assim está bom!'
                  placeholder='Insira a localização'
                />
              </FormGroup>
              <FormGroup id='serial' label='Número de Série' className='col-md-9 mb-4 '>
                <Input
                  id='serial'
                  name='serial'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.serial}
                  isValid={formik.isValid}
                  isTouched={formik.touched.serial}
                  invalidFeedback={formik.errors.serial}
                  validFeedback='Assim está bom!'
                  placeholder='Insira o número de série'
                />
              </FormGroup>
              <FormGroup className='col-md-3'>
                <Label>Status</Label>
                <ChecksGroup
                  isValid={formik.isValid}
                  isTouched={formik.touched.active}
                  invalidFeedback={formik.errors.active}
                >
                  <Checks
                    type="radio"
                    id="active"
                    label="Ativo"
                    name="active"
                    value="ativo"
                    onChange={formik.handleChange}
                    checked={formik.values.active}
                    isInline
                  />
                  <Checks
                    type="radio"
                    id="active2"
                    label="Inativo"
                    name="active"
                    value="inativo"
                    onChange={formik.handleChange}
                    checked={formik.values.active}
                    isInline
                  />
                </ChecksGroup>
              </FormGroup>
            </div>
          </div>
          <div className="row pt-4">
            <div className='d-flex justify-content-end gap-2'>
              <Button
                color="danger"
                icon="cancel"
                rounded={1}
                onClick={handleClose}
                shadow="sm"
                hoverShadow="sm"
                size="sm"
              >
                Cancelar
              </Button>
              {isLoading ? (
                <Button
                  color="success"
                  rounded={1}
                  hoverShadow="sm"
                  shadow="sm"
                  size="sm"
                >
                  <Spinner
                    color="light"
                    inButton
                    isGrow
                    isSmall
                    size={10}
                    tag="span"
                  >
                    Carregando...
                  </Spinner>
                  Carregando...
                </Button>
              ) : (
                <Button
                  type="submit"
                  color="success"
                  icon="check"
                  rounded={1}
                  hoverShadow="sm"
                  shadow="sm"
                  size="sm"
                  disabled={!formik.isValid || isLoading}
                >
                  Confirmar
                </Button>
              )}
            </div>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default ModalRegisterTerminal;
